import { useDispatch } from 'react-redux';

import { getStreets } from '@entities/delivery';

import { Field } from '@shared/form';

import { useTypedSelector } from '@shared/lib/use-typed-selector';

import { useCityId, useIsCityEntered } from '../model';

import styles from './add-receiver-info-ut-form.module.scss';

const CityStreetSearchInput = () => {
  const dispatch = useDispatch();
  const { searchStreetsResult, searchStreetsPending } = useTypedSelector(
    state => state.delivery
  );

  const isCityEntered = useIsCityEntered();
  const cityId = useCityId();

  const onCitySearchQueryChange = (query: string) => {
    if (query.length < 2) return;

    if (!cityId) return;

    dispatch(getStreets(query, cityId));
  };

  const onReset = () => {
    dispatch(getStreets.reset());
  };

  return (
    <Field.Search
      className={styles.field}
      name='street'
      type='search'
      label='Вулиця'
      options={searchStreetsResult}
      onQueryChange={onCitySearchQueryChange}
      onBlur={onReset}
      disabled={!isCityEntered}
      loading={searchStreetsPending}
    />
  );
};

export { CityStreetSearchInput };
